exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".City-module__city___38w9k{display:flex;justify-content:center;align-items:center;height:var(--app-height);width:100vw;background-color:#b7b7b7;position:relative;overflow:hidden}.City-module__city___38w9k .City-module__p-center___3cVWA{position:absolute;transform:scale(1);width:150vw;height:calc(var(--app-height)*1.5)}.City-module__city___38w9k .City-module__p-top-left___wv9eK{position:absolute;top:-80px;left:-120px}@media screen and (min-height:1000px){.City-module__city___38w9k .City-module__p-top-left___wv9eK{top:50px}}.City-module__city___38w9k .City-module__p-bottom-left___3nxq7{position:absolute;bottom:-330px;left:-220px}.City-module__city___38w9k .City-module__po-bottom-right___gXit8{position:absolute;bottom:-80px;right:-110px}", ""]);

// exports
exports.locals = {
	"city": "City-module__city___38w9k",
	"p-center": "City-module__p-center___3cVWA",
	"p-top-left": "City-module__p-top-left___wv9eK",
	"p-bottom-left": "City-module__p-bottom-left___3nxq7",
	"po-bottom-right": "City-module__po-bottom-right___gXit8"
};